import DOMPurify from "dompurify";
import parse from "html-react-parser";
import { PrevNextNavigation } from "./PrevNextNavigation";
import { useSelect } from "@wordpress/data";
import { STORE_NAME } from "../store";
import { highlightSearchTerm } from './highlightSearchTerm';

export const Verse = ( {
	title,
	sanskrit,
	wordForWord,
	translation,
	commentary
} ) => {
	const verses = useSelect( select => select( STORE_NAME ).getVerses(), []);
	const chapters = useSelect( select => select( STORE_NAME ).getChapters(), []);
	const searchTerm = useSelect( select => select( STORE_NAME ).getSearchTerm(), [] );

	if( verses.length < 2 ) {
		return null;
	}
	const verseNum = title.split(".")[1];

	const getNext = () => {
		const currentVerseIndex = verses.findIndex(verse => verse.title === title);
		if (currentVerseIndex < verses.length - 1) {
			return verses[currentVerseIndex + 1];

		}
		// get the next chapter
		const currentChapterIndex = chapters.findIndex(chapter => chapter.current);
		if (currentChapterIndex < chapters.length - 1) {
			return chapters[currentChapterIndex + 1];

		}
		return null;
	}
	const getPrev = () => {
		const currentVerseIndex = verses.findIndex(verse => verse.title === title);
		if (currentVerseIndex > 0) {
			return verses[currentVerseIndex - 1];
		}``
		// get the previous chapter
		const currentChapterIndex = chapters.findIndex(chapter => chapter.current);
		if (currentChapterIndex > 0) {
			return chapters[currentChapterIndex - 1];
		}
		return null;
	}

	return (
		<>
			<div className="bbt-advanced-view" > 
				<h1 className="mt-5 mb-2 text-center">{`${verseNum.includes("-") ? "פסוקים" : "פסוק"} ${verseNum}`}</h1>
			
				<div className="text-center" >{ parse(DOMPurify.sanitize(
					searchTerm ? highlightSearchTerm( sanskrit, searchTerm ) : sanskrit)) }</div>

				<h4>מילה למילה</h4>
				<div className="text-justify" >
					{parse(DOMPurify.sanitize(
						searchTerm ? highlightSearchTerm(wordForWord, searchTerm) : wordForWord))}
				</div>
	
				<h4>תרגום</h4>
				<strong className="bbt-verse-content">
					{parse(DOMPurify.sanitize(
						searchTerm ? highlightSearchTerm(translation, searchTerm) : translation))}
				</strong>
	
				{ commentary && (
					<>
						<h4>התעמקות</h4>
						<div
							className="text-justify"
						>
							{parse(DOMPurify.sanitize(
								searchTerm ? highlightSearchTerm(commentary, searchTerm) : commentary))}
						</div>
					</>
				)}
			</div>
			<PrevNextNavigation prev={getPrev()} next={getNext()} />
		</>);
};
